import React from 'react'

import { Collapse, Popover } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

import { Button, Drawer, Input, InputGroup, Loader, Modal } from 'rsuite'

import { Divider, IconButton, Stack } from '@mui/material'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined'

import Icon from '@mdi/react'
import { mdiFilterOutline } from '@mdi/js'

import { BootstrapTooltip } from '../../_ui/tooltip'
import emptyDoc from './../../../img/empty_documents.svg'
import Empty from '../../_ui/empty'

import css from './rpd.module.scss'
import Dropzone from 'react-dropzone'

const { Panel } = Collapse

const Rpd = (props: any) => {
    return (
        <>
            <CreateSpecialtyCode {...props} />
            <CreateDisciplines {...props} />

            <DeleteSection {...props} />
            <EditSection {...props} />

            <div className={css.main}>
                <div className={css.mainHeader}>
                    <div className={css.mainHeaderTitle}>РПД - Список направлений подготовки ({props.specialtyCodesList.length})</div>

                    <InputGroup inside style={{ width: "300px" }} disabled={props.specialtyCodesList.length ? false : true}>
                        <InputGroup.Addon>
                            <Icon path={mdiFilterOutline} size={1} style={{ margin: "2px 0 0 -6px" }} />
                        </InputGroup.Addon>

                        <Input type="text" size="md" placeholder="Фильтр..."
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.valueFilterDirectionTraining}
                            onChange={value => props.setValueFilterDirectionTrainig(value)}
                        />

                        {props.valueFilterDirectionTraining &&
                            <InputGroup.Addon onClick={() => props.setValueFilterDirectionTrainig('')} style={{ margin: "auto 0" }}>
                                <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                    <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                        <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                    </IconButton>
                                </BootstrapTooltip>
                            </InputGroup.Addon>
                        }
                    </InputGroup>

                    <BootstrapTooltip title="Создать направление подготовки" placement="bottom" arrow>
                        <div className='myButtonIconTextPrimary' onClick={(e) => props.openCreateDirectionTraining(true)}>
                            <AddCircleOutlineOutlinedIcon sx={{ fontSize: 26 }} />
                            <span>СОЗДАТЬ</span>
                        </div>
                    </BootstrapTooltip>
                </div>

                <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

                <div className={css.mainBody}>
                    <div className={css.tBody}>
                        {!props.specialtyCodesList.length
                            ? <Empty image={emptyDoc} description="Данные отсутствуют" />
                            : <Collapse accordion bordered={false} onChange={props.selectSpecialtyCode} className='collapseItems' expandIcon={({ isActive }) => <PlusOutlined style={{ color: `#FF9900`, fontSize: '26px' }} rotate={isActive ? -45 : 0} />}>
                                {
                                    props.specialtyCodesList.filter((val: any) => {
                                        let stringReturn

                                        let specialty_code_name = val.specialty_code_name.toLowerCase().includes(props.valueFilterDirectionTraining.toLowerCase())

                                        if (specialty_code_name) {
                                            stringReturn = val
                                        }

                                        return stringReturn
                                    }).map((item: any) => {
                                        return (
                                            <Panel key={item.specialty_code_id} id={item.specialty_code_id} className='collapseItem'
                                                header={
                                                    <div className='panelHeader'>
                                                        <div className='panelTitle'>{item.specialty_code_name}</div>

                                                        <BootstrapTooltip title="Редактировать" placement="bottom" arrow>
                                                            <div className='myButtonIconPrimary'
                                                                onClick={(e) => {
                                                                    props.openEditSection(true, 'specialty', item.specialty_code_id, item.specialty_code_name)
                                                                    e.stopPropagation()
                                                                }}
                                                            ><EditOutlinedIcon sx={{ fontSize: 26 }} /></div>
                                                        </BootstrapTooltip>

                                                        <BootstrapTooltip title="Удалить" placement="bottom" arrow>
                                                            <div className='myButtonIconPrimary'
                                                                onClick={(e) => {
                                                                    props.openDeleteSection(true, 'specialty', item.specialty_code_id, item.specialty_code_name)
                                                                    e.stopPropagation()
                                                                }}
                                                            ><DeleteOutlineOutlinedIcon sx={{ fontSize: 26 }} /></div>
                                                        </BootstrapTooltip>

                                                        <BootstrapTooltip title="Скопировать ссылку в буфер" placement="bottom" arrow>
                                                            <div className='myButtonIconPrimary'
                                                                onClick={(e) => {
                                                                    props.copyLink(`${window.location.origin}/rpd/${item.specialty_code_id}`)
                                                                    e.stopPropagation()
                                                                }}
                                                            ><InsertLinkOutlinedIcon sx={{ fontSize: 26 }} /></div>
                                                        </BootstrapTooltip>
                                                    </div>
                                                }>
                                                <>
                                                    {props.isVisibleLoaderDisciplines
                                                        ? <div style={{ height: "100px", position: "relative", background: "transparent" }}><Loader center size="md" content="Загрузка данных..." vertical /> </div>
                                                        : <Disciplines {...props} />
                                                    }
                                                </>
                                            </Panel>
                                        )
                                    })
                                }
                            </Collapse>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}



// Дисцплины
const Disciplines = (props: any) => {
    return (
        <div className={css.main}>
            <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

            <div className={css.mainHeader}>
                <div className={css.mainHeaderTitle}>Список дисциплин ({props.disciplinesList.length})</div>

                <BootstrapTooltip title="Создать дисциплину" placement="bottom" arrow>
                    <div className='myButtonIconTextPrimary' onClick={(e) => props.openCreateDisciplines(true)}>
                        <AddCircleOutlineOutlinedIcon sx={{ fontSize: 26 }} />
                        <span>СОЗДАТЬ</span>
                    </div>
                </BootstrapTooltip>

            </div>

            <div className={css.mainBody}>
                <div className={css.tBodyDiscipline}>
                    {!props.disciplinesList.length
                        ? <Empty image={emptyDoc} description="Данные отсутствуют" heightImg='150px' mainHeight='300px' />
                        : <Collapse accordion bordered={false} onChange={props.selectDiscipline} className='collapseItemsSecondary' expandIcon={({ isActive }) => <PlusOutlined style={{ color: `#FF9900`, fontSize: '26px' }} rotate={isActive ? -45 : 0} />}>
                            {
                                props.disciplinesList.map((item: any) => {
                                    return (
                                        <Panel key={item.discipline_id} id={item.discipline_id} className='collapseItem'
                                            header={
                                                <div className='panelHeader'>
                                                    <div className='panelTitle'>{item.discipline_name}</div>

                                                    <BootstrapTooltip title="Редактировать" placement="bottom" arrow>
                                                        <div className='myButtonIconPrimary'
                                                            onClick={(e) => {
                                                                props.openEditSection(true, 'discipline', item.discipline_id, item.discipline_name)
                                                                e.stopPropagation()
                                                            }}
                                                        ><EditOutlinedIcon sx={{ fontSize: 26 }} /></div>
                                                    </BootstrapTooltip>

                                                    <BootstrapTooltip title="Удалить" placement="bottom" arrow>
                                                        <div className='myButtonIconPrimary'
                                                            onClick={(e) => {
                                                                props.openDeleteSection(true, 'discipline', item.discipline_id, item.discipline_name)
                                                                e.stopPropagation()
                                                            }}
                                                        ><DeleteOutlineOutlinedIcon sx={{ fontSize: 26 }} /></div>
                                                    </BootstrapTooltip>

                                                    <BootstrapTooltip title="Скопировать ссылку в буфер" placement="bottom" arrow>
                                                        <div className='myButtonIconPrimary'
                                                            onClick={(e) => {
                                                                props.copyLink(`${window.location.origin}/rpd/${item.discipline_link}`)
                                                                e.stopPropagation()
                                                            }}
                                                        ><InsertLinkOutlinedIcon sx={{ fontSize: 26 }} /></div>
                                                    </BootstrapTooltip>
                                                </div>
                                            }>
                                            <>
                                                {props.isVisibleLoaderFiles
                                                    ? <div style={{ height: "100px", position: "relative", background: "transparent" }}><Loader center size="md" content="Загрузка данных..." vertical /> </div>
                                                    : <Files {...props} />
                                                }
                                            </>
                                        </Panel>
                                    )
                                })
                            }
                        </Collapse>
                    }
                </div>
            </div>
        </div>
    )
}

// Файлы
const Files = (props: any) => {
    return (
        <div className={css.main}>
            <div className='dividerPrimary'></div>

            <div className={css.mainHeader}>
                <div className={css.mainHeaderTitle} style={{ color: '#fff' }}>Список файлов ({props.filesList.length})</div>
            </div>

            <Dropzone onDropAccepted={(files) => props.fileUploader(files)} multiple={true}>
                {({ getRootProps, getInputProps, isDragAccept, isDragActive }) => (
                    <div {...getRootProps({ className: isDragAccept ? `${css.myDropZone}` : `${css.mainBody}`, onClick: event => event.stopPropagation() })}>
                        <input {...getInputProps()} />
                        <div className={css.tHeaderFiles}>
                            <div id={css.name}>Имя файла</div>
                            <div id={css.uid}>Дата загрузки</div>
                            <div id={css.btn}></div>
                        </div>

                        {!props.filesList.length
                            ? <Empty image={emptyDoc} description="Данные отсутствуют" heightImg='150px' mainHeight='300px' />
                            :
                            <div className={css.tBodyFiles}>
                                {props.filesList.map((item: any) => {
                                    return (
                                        <div key={item.file_id} className={css.tRowFiles}>
                                            <div id={css.name}>{item.file_name}</div>
                                            <div id={css.uid}>{item.create_date_time}</div>
                                            <div id={css.btn}>
                                                <Popover placement="bottom" trigger="click"
                                                    content={
                                                        <Stack spacing={1.5} style={{ padding: "10px" }}>
                                                            <div style={{ fontSize: "15px", letterSpacing: "1px", fontWeight: "600" }}>Удалить этот файл?</div>
                                                            <div className='myButtonPrimary'
                                                                onClick={() => props.deleteBtnFiles(item.file_id, item.file_name)}
                                                            >ДА</div>
                                                        </Stack>
                                                    }>

                                                    <div>
                                                        <BootstrapTooltip title="Удалить" placement="bottom" arrow>
                                                            <div className='myButtonIconPrimary'>
                                                                <DeleteOutlineOutlinedIcon sx={{ fontSize: 26 }} />
                                                            </div>
                                                        </BootstrapTooltip>
                                                    </div>
                                                </Popover>

                                                <BootstrapTooltip title="Просмотр файла" placement="bottom" arrow>
                                                    <a href={item.file_path} className='myButtonIconPrimary' target='_blank' rel="noreferrer">
                                                        <FileDownloadOutlinedIcon sx={{ fontSize: 26 }} />
                                                    </a>
                                                </BootstrapTooltip>

                                            </div>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        }
                    </div>
                )}
            </Dropzone>
        </div>
    )
}



// Создание направления подготовки
const CreateSpecialtyCode = (props: any) => {
    return (
        <Drawer backdrop='static' size='full' autoFocus={true} open={props.getOpenCreateDirectionTraining} style={{ maxWidth: '900px' }}>
            <section className='drawerMain'>
                <header className='drawerHeader'>
                    <h4>Создание направления подготовки</h4>

                    <BootstrapTooltip title="Закрыть" placement="bottom" arrow>
                        <div className='myButtonIconPrimary' onClick={() => props.openCreateDirectionTraining(false)}>
                            <CloseOutlinedIcon sx={{ fontSize: 26 }} />
                        </div>
                    </BootstrapTooltip>
                </header>

                <main className='drawerContent'>
                    <div className='myInputTextPrimary'>
                        <input type="text" placeholder='Введите код направления подготовки / специальности'
                            value={props.valueDirectionTraining} onChange={e => props.setValueDirectionTrainig(e.target.value)}
                        />
                    </div>

                    <section className={css.addedDisciplineContent}>
                        <h5>Создание дисциплин</h5>

                        <div className={css.addedDisciplineList}>
                            {props.valueListDisciplines.map((item: any, index: any) => {
                                return (
                                    <div className={css.item} key={index}>
                                        <div className='myInputTextPrimary'>
                                            <input type="text" placeholder='Введите наименование дисциплины'
                                                value={item} onChange={props.editValueDiscipline(index)}
                                            />
                                        </div>

                                        <BootstrapTooltip title="Удалить" placement="bottom" arrow>
                                            <div className='myButtonIconPrimary' onClick={() => props.deleteItemDiscipline(index)}>
                                                <RemoveCircleOutlineOutlinedIcon sx={{ fontSize: 26 }} />
                                            </div>
                                        </BootstrapTooltip>
                                    </div>
                                )
                            })}

                            <div className='myButtonIconTextPrimary' onClick={props.addDiscipline}>
                                <AddCircleOutlineOutlinedIcon sx={{ fontSize: 26 }} />
                                <span>ДОБАВИТЬ ДИСЦИПЛИНУ</span>
                            </div>
                        </div>
                    </section>

                    <div className='myButtonPrimary' onClick={props.createBtnDirectionTraining}>
                        <span>СОЗДАТЬ</span>
                    </div>
                </main>
            </section>
        </Drawer>
    )
}

// Создание дисциплин
const CreateDisciplines = (props: any) => {
    return (
        <Drawer backdrop='static' size='full' autoFocus={true} open={props.getOpenCreateDisciplines} style={{ maxWidth: '900px' }}>
            <section className='drawerMain'>
                <header className='drawerHeader'>
                    <h4>Создание дисциплин</h4>

                    <BootstrapTooltip title="Закрыть" placement="bottom" arrow>
                        <div className='myButtonIconPrimary' onClick={() => props.openCreateDisciplines(false)}>
                            <CloseOutlinedIcon sx={{ fontSize: 26 }} />
                        </div>
                    </BootstrapTooltip>
                </header>

                <main className='drawerContent'>
                    <section className={css.addedDisciplineContent}>
                        <div className={css.addedDisciplineList}>
                            {props.valueListDisciplines.map((item: any, index: any) => {
                                return (
                                    <div className={css.item} key={index}>
                                        <div className='myInputTextPrimary'>
                                            <input type="text" placeholder='Введите наименование дисциплины'
                                                value={item} onChange={props.editValueDiscipline(index)}
                                            />
                                        </div>

                                        <BootstrapTooltip title="Удалить" placement="bottom" arrow>
                                            <div className='myButtonIconPrimary' onClick={() => props.deleteItemDiscipline(index)}>
                                                <RemoveCircleOutlineOutlinedIcon sx={{ fontSize: 26 }} />
                                            </div>
                                        </BootstrapTooltip>
                                    </div>
                                )
                            })}

                            <div className='myButtonIconTextPrimary' onClick={props.addDiscipline}>
                                <AddCircleOutlineOutlinedIcon sx={{ fontSize: 26 }} />
                                <span>ДОБАВИТЬ ДИСЦИПЛИНУ</span>
                            </div>
                        </div>
                    </section>

                    <div className='myButtonPrimary' onClick={props.createBtnDisciplines}>
                        <span>СОЗДАТЬ</span>
                    </div>
                </main>
            </section>
        </Drawer>
    )
}



// Окно с подстверждением удаления направления подготовки и дисциплин
const DeleteSection = (props: any) => {
    return (
        <Modal backdrop="static" size="xs" autoFocus={false} open={props.isVisibleDeleteSection}>
            <div className="modal">
                <div className="modalHead">
                    {props.actionSection === 'specialty' && 'Удаление направление подготовки...'}
                    {props.actionSection === 'discipline' && 'Удаление дисциплины...'}
                </div>

                <div className="modalBody">
                    {props.actionSection === 'specialty' && 'Вы действительно хотите удалить выбранное Вами направление подготовки?'}
                    {props.actionSection === 'discipline' && 'Вы действительно хотите удалить выбранную Вами дисциплину?'}
                </div>

                <div className="modalFooter">
                    <Button size="md" appearance="default" onClick={() => props.openDeleteSection(false)}>ОТМЕНА</Button>
                    <Button size="md" appearance="primary" onClick={props.deleteBtnSection}>ДА</Button>
                </div>
            </div>
        </Modal>
    )
}

// Окно редактирования направления подготовки и дисциплин
const EditSection = (props: any) => {
    return (
        <Modal backdrop="static" size="sm" autoFocus={false} open={props.isVisibleEditSection}>
            <div className="modal" style={{ gap: '30px' }}>
                <div className="modalHead">
                    {props.actionSection === 'specialty' && 'Редактирование направление подготовки...'}
                    {props.actionSection === 'discipline' && 'Редактирование дисциплины...'}
                </div>

                <div className="modalBody">
                    <div className='myInputTextPrimary'>
                        <input type="text" placeholder='Наименование'
                            value={props.sectionName} onChange={e => props.setSectionName(e.target.value)}
                        />
                    </div>
                </div>

                <div className="modalFooter">
                    <Button size="md" appearance="default" onClick={() => props.openEditSection(false)}>ОТМЕНА</Button>
                    <Button size="md" appearance="primary" onClick={props.editBtnSection}>ПРИМЕНИТЬ</Button>
                </div>
            </div>
        </Modal>
    )
}

export default Rpd